"use client";
import {
  Link
} from "./chunk-5SU2O5AS.js";
import "./chunk-BBP7MIO4.js";
import "./chunk-MLKGABMK.js";
export {
  Link as default
};
